var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crear-version screen page formActions b-soft"},[_c('div',{staticClass:"grid"},[_c('formVersion',{attrs:{"prop_cotizacion":_vm.cotizacion},on:{"actionChange":_vm.onActionChange}}),_c('GetFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }